/**
 * Trait names for integration link spotlight
 *
 * TWO-TRAIT SYSTEM:
 * 1. STATE trait: JSON format with stage and timestamp (e.g., '{"stage":1,"timestamp":1704512000000}')
 * 2. HARD_DISMISS trait: 'true' or 'false'
 *
 * This separation allows analytics events to update traits independently:
 * - "Shown" event → updates STATE trait
 * - "Hard Dismiss" event → updates HARD_DISMISS trait
 */

// STATE traits: store stage + lastShownTimestamp
export const TRAIT_NAMES_STATE = {
	SLACK: 'confluence_ui_integrationspotlightshownforslack_viewed_changed',
	TEAMS: 'confluence_ui_integrationspotlightshownforteams_viewed_changed',
	INVITE_ON_3P_SLACK: 'confluence_ui_slack3pwithin1pspotlightshown_viewed_changed',
	INVITE_ON_3P_MAILTO: 'confluence_ui_mailto3pwithin1pspotlightshown_viewed_changed',
};

// HARD_DISMISS traits: store boolean as string
export const TRAIT_NAMES_HARD_DISMISS = {
	SLACK: 'confluence_ui_integrationspotlightdismissedforslack_clicked_changed',
	TEAMS: 'confluence_ui_integrationspotlightdismissedforteams_clicked_changed',
	INVITE_ON_3P_SLACK: 'confluence_ui_slack3pwithin1pspotlightdismissed_clicked_changed',
	INVITE_ON_3P_MAILTO: 'confluence_ui_mailto3pwithin1pspotlightdismissed_clicked_changed',
};

// localStorage key for 15-minute global throttle
export const LAST_FLAG_SHOWN_TIMESTAMP_KEY = 'integration_spotlight_last_shown_timestamp';

export const STORAGE_3P_FLAG_SHOWN_ELIGIBILITY_KEY =
	'growth.experiment.confluence.3p-within-1p-spotlight-eligibility';
